import { Component, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth/auth.service';
import { CoreService } from '../../core.service';
import { UserChangePasswordFormDialogComponent } from '../../../user/components/user-change-password-form-dialog/user-change-password-form-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  isMobile$ = this.core.isMobile$;
  environment = environment;

  @ViewChild('userChangePasswordFormDialog', { static: false })
  userChangePasswordFormDialog?: UserChangePasswordFormDialogComponent;

  innerWidth = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Output() showSideMenu = new EventEmitter<boolean>();

  role$ = this.authService.roles$;
  roleLiteral$ = this.authService.roleLiterals$;
  // username$ = this.store$.select(AuthSelect.username);

  token$ = this.authService.token$;

  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
      window.location.href.indexOf('local') !== -1
      ? true
      : false;
  userMenuItems: MenuItem[] = [];

  constructor(
    private core: CoreService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userMenuItems = [
      {
        label: 'Αλλαγή Κωδικού',
        icon: 'pi pi-key',
        command: () => {
          this.userChangePasswordFormDialog?.show();
        },
      },
      {
        label: 'Αποσύνδεση',
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logout();
        },
      },
    ];
  }

  onChangePasswordSuccess() {
    this.core.showSuccess(
      'Παρακαλώ μπείτε εκ νέου στην πλατφόρμα χρησιμοποιώντας τον καινούργιο κωδικό',
      'Ο κωδικός χρήστη ενημερώθηκε!'
    );
    this.authService.logout();
  }

  onUserButtonClick() {
    //this.router.navigate(['doctor/profile']);
  }

  getNameAndRole(): string {
    const data = this.token$.getValue();
    const name = data?.name ?? 'Unknown';
    const role = this.getRoleLiterals(Array.isArray(data?.role) ? data.role : (data?.role ? [data.role] : []));
    return `${name} - ${role}`;
  }

  getRoleLiterals(roles: string[]) {
    const roleArray = roles;

    if (!roleArray || roleArray?.length === 0) return 'Ν/Α';

    switch (roleArray[0]) {
      case 'Admin':
        return 'Διαχειριστής Κεντρικού Συστήματος';
      case 'SimpleAdmin':
        return 'Απλός Διαχειριστής';
      case 'ApiRequester':
        return 'Αιτών API';
      default:
        return 'Ν/Α';
    }
  }

  onLogoClick() {
    this.router.navigate(['/home']);
  }
}
